import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import type { Action } from 'redux-actions';
import { dialogStatisticsAddDialogStatistic, dialogStatisticsListDialogStatisticsService } from '@/api-gen/api';
import type { DialogStatisticsListDialogStatisticsServiceParams } from '@/api-gen/api.schemas';
import * as DashboardActions from 'app/actions/dasboard/dashboardActions.ts';
import type { AxiosResponse } from 'axios';
import type { PartialListDialogStatisticDto } from '@/api-gen/api.schemas';
import { EndReason } from '@/api-gen/api.schemas';

import * as DialogProcessorSelector from 'app/selectors/dialogProcessorSelector.ts';
import * as ScenarioActions from 'app/actions/scenarios/scenarioAction.ts';
import type { IDProcessState } from 'app/models/dialogs/dialogProcess.ts';
import type { DialogStatisticIntentWithUserVoice } from 'app/models/statistic/statistic.ts';
import logger from 'app/utils/logger.ts';

function* postDialogStatistics({
  payload: { intents, start, end }
}: Action<{ intents: DialogStatisticIntentWithUserVoice[]; start: string; end: string }>) {
  try {
    // if (!intents.length) return;

    yield put(ScenarioActions.setDetailedScenarioLoading(true));

    const dialogProcessorHistory: IDProcessState = yield select(DialogProcessorSelector.dialogProcessorSelector);

    yield call(dialogStatisticsAddDialogStatistic, {
      sessionId: dialogProcessorHistory.sessionId,
      endReason: EndReason.Finish
    } as any);
  } catch (error) {
    logger.error(error);
    yield put(ScenarioActions.setDetailedScenarioLoading(false));
  } finally {
    yield put(ScenarioActions.setDetailedScenarioLoading(false));
  }
}

function* getDialogStatistics({
  payload: {
    skip,
    take,
    order,
    orderBy,
    from,
    to,
    search,
    selectedId,
    companyName,
    departmentName,
    scenarioName,
    userName,
    durationMin,
    durationMax,
    scoreMin,
    scoreMax,
    isPhoneConversation
  }
}: Action<DashboardActions.PayloadType['dashboard/GET_DIALOG_STATISTICS']>) {
  try {
    yield put(DashboardActions.setStatisticsLoading(true));
    const params: DialogStatisticsListDialogStatisticsServiceParams = {
      Skip: skip,
      Take: take,
      SortOrder: order as any,
      OrderBy: orderBy,
      From: from?.toISOString(),
      To: to?.toISOString(),
      Search: search,
      CompanyName: companyName,
      DepartmentName: departmentName,
      ScenarioName: scenarioName,
      UserName: userName,
      DurationMin: durationMin,
      DurationMax: durationMax,
      ScoreMin: scoreMin,
      ScoreMax: scoreMax,
      selectedId: selectedId,
      IsPhoneConversation: isPhoneConversation
    };
    const response: AxiosResponse<PartialListDialogStatisticDto> = yield call(
      dialogStatisticsListDialogStatisticsService,
      params
    );
    yield put(DashboardActions.putDialogStatistics(response.data));
  } catch (e) {
    logger.error('Cannot get dialog statistics');
  } finally {
    yield put(DashboardActions.setStatisticsLoading(false));
  }
}

export default function* watchAllDashboardsSaga() {
  yield all([
    yield takeEvery(DashboardActions.ActionType.GetDialogStatistics, getDialogStatistics),
    yield takeEvery(DashboardActions.ActionType.PostDialogStatistics, postDialogStatistics)
  ]);
}
